import numeral from 'numeral';

export default (value: number | string, format: string): string => {
  const val = Math.abs(+value) < 0.000001 ? 0 : value;

  return isNaN(+val) ? val : numeral(val).format(format).replace(/,/g, ' ');
};
